import React, { Component } from 'react';
import styles from './Home.module.css';
import { ThemeProvider } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import firebase from '../helpers/firebase';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import zipcodes from 'zipcodes';
import TextField from '@material-ui/core/TextField';
import Modal from '@material-ui/core/Modal';
import { Helmet } from 'react-helmet';
import NetworkToolbar from './NetworkToolbar';
import { darkTheme } from './darkTheme';

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allPosts: {},
      posts: {},
      searchValue: '',
      activeRightNow: '',
      buyCheck: true,
      sellCheck: true,
      fruitsCheck: true,
      vegetablesCheck: true,
      meatCheck: true,
      otherCheck: true,
      miles: '',
      currentZipCode: '',
      introModalOpen: false,
    };
  }

  async componentDidMount(): void {
    const postCollection = await firebase
      .firestore()
      .collection('network')
      .doc('posts')
      .collection('posts')
      .get();
    let posts = {};
    postCollection.docs.forEach((doc) => {
      posts[doc.id] = doc.data();
    });
    let searchValue = localStorage.getItem('searchValue');
    if (!searchValue) {
      searchValue = '';
    }
    this.setState(
      {
        posts,
        allPosts: posts,
        searchValue,
        activeRightNow: parseInt(Math.random() * 50 + 20),
      },
      this.updateResults
    );
    localStorage.setItem('searchValue', '');
    setInterval(() => {
      this.setState({
        activeRightNow:
          this.state.activeRightNow + parseInt(Math.random() * 4 - 2),
      });
    }, 1000);
  }

  updateResults = () => {
    let posts = {};
    let radius = zipcodes.radius(this.state.currentZipCode, this.state.miles);
    Object.keys(this.state.allPosts).forEach((post) => {
      if (
        this.state.allPosts[post]['post_title']
          .toLowerCase()
          .includes(this.state.searchValue.toLowerCase())
      ) {
        if (
          (this.state.buyCheck === true &&
            this.state.allPosts[post]['type'] === 'buy') ||
          (this.state.sellCheck === true &&
            this.state.allPosts[post]['type'] === 'sell')
        ) {
          if (
            (this.state.fruitsCheck === true &&
              this.state.allPosts[post]['category'] === 'fruits') ||
            (this.state.vegetablesCheck === true &&
              this.state.allPosts[post]['category'] === 'vegetables') ||
            (this.state.meatCheck === true &&
              this.state.allPosts[post]['category'] === 'meat') ||
            (this.state.otherCheck === true &&
              this.state.allPosts[post]['category'] === 'other')
          ) {
            if (
              this.state.currentZipCode === '' ||
              this.state.miles === '' ||
              radius.includes(this.state.allPosts[post]['zip_code'])
            ) {
              posts[post] = this.state.allPosts[post];
            }
          }
        }
      }
    });
    this.setState({ posts });
  };

  handleChangeSearchValue = (event) => {
    this.setState({ searchValue: event.target.value }, this.updateResults);
  };
  handleChangeBuyCheck = (_) => {
    this.setState({ buyCheck: !this.state.buyCheck }, this.updateResults);
  };
  handleChangeSellCheck = (_) => {
    this.setState({ sellCheck: !this.state.sellCheck }, this.updateResults);
  };
  handleChangeFruitsCheck = (_) => {
    this.setState({ fruitsCheck: !this.state.fruitsCheck }, this.updateResults);
  };
  handleChangeVegetablesCheck = (_) => {
    this.setState(
      { vegetablesCheck: !this.state.vegetablesCheck },
      this.updateResults
    );
  };
  handleChangeMeatCheck = (_) => {
    this.setState({ meatCheck: !this.state.meatCheck }, this.updateResults);
  };
  handleChangeOtherCheck = (_) => {
    this.setState({ otherCheck: !this.state.otherCheck }, this.updateResults);
  };
  handleChangeMiles = (event) => {
    this.setState({ miles: event.target.value }, this.updateResults);
  };
  handleChangeCurrentZipCode = (event) => {
    this.setState({ currentZipCode: event.target.value }, this.updateResults);
  };
  handleModalClose = () => {
    this.setState({ introModalOpen: false });
  };
  handleModalOpen = () => {
    this.setState({ introModalOpen: true });
  };

  render() {
    return (
      <ThemeProvider theme={darkTheme}>
        <div>
          <Helmet>
            <meta
              name="description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others"
            />

            <meta
              itemProp="name"
              content="DeWaste Network | Connecting food producers and buyers to reduce food waste"
            />
            <meta
              itemProp="description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others in their proximity and trade in these food items so they don't go to waste."
            />
            <meta
              itemProp="image"
              content="https://de-waste.com/network_logo.png"
            />

            <meta
              property="og:image"
              content="https://de-waste.com/network_logo.png"
            />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="DeWaste Network" />
            <meta
              property="og:description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others."
            />
            <meta property="og:site_name" content="DeWaste" />
            <meta property="og:url" content="https://de-waste.com/network" />

            <meta name="twitter:card" content="summary" />
            <meta
              name="twitter:image"
              content="https://de-waste.com/network_logo.png"
            />
            <meta name="twitter:title" content="DeWaste Network" />
            <meta
              name="twitter:description"
              content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others."
            />

            <title>
              DeWaste Network | Connecting food producers and consumers
            </title>
          </Helmet>

          <Modal
            open={this.state.introModalOpen}
            onClose={this.handleModalClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <div className={styles.introModalDiv}>
              <div className={styles.modalHeaderText}>
                <br />
                <span>Welcome to the DeWaste Network!</span>
              </div>

              <div className={styles.modalDescription}>
                <br />
                <span>
                  The DeWaste Network is an online platform where farmers,
                  wholesalers, retailers and customers can connect with others
                  in their proximity and trade in these food items so they don't
                  go to waste.
                </span>
              </div>

              <div className={styles.modalSubHeader}>
                <span>Types of Posts</span>
              </div>
              <div className={styles.modalText}>
                <span>
                  There are posts where listers are selling something or buying
                  something and these are color coded on the homepage.
                </span>
              </div>

              <div className={styles.modalSubHeader}>
                <span>Make a Post</span>
              </div>
              <div className={styles.modalText}>
                <span>
                  Click the "Make a New Post" button in the top right. Fill in
                  the fields regarding what you are looking to buy/sell and
                  submit the post! Your post will be approved shortly by the
                  admin team.
                </span>
              </div>

              <Button
                variant={'contained'}
                className={styles.dismissButton}
                color={'primary'}
                onClick={this.handleModalClose}
              >
                Dismiss
              </Button>
            </div>
          </Modal>

          <NetworkToolbar
            handleChangeSearchValue={this.handleChangeSearchValue}
            searchValue={this.state.searchValue}
          />

          <div className={styles.placeholder} />
          <div className={styles.placeholder} />
          <div className={styles.placeholder} />
          <div className={styles.placeholder} />

          <div className={styles.networkFiltersDiv}>
            <div className={styles.howToUseButtonDiv}>
              <Button
                variant={'contained'}
                color={'primary'}
                className={styles.howToUseButton}
                onClick={this.handleModalOpen}
              >
                How To Use?
              </Button>
            </div>
            <div className={styles.filterInnerDiv}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Type of Posts</FormLabel>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={this.state.buyCheck}
                        onChange={this.handleChangeBuyCheck}
                      />
                    }
                    label="Buying"
                  />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={this.state.sellCheck}
                        onChange={this.handleChangeSellCheck}
                      />
                    }
                    label="Selling"
                  />
                </FormGroup>
              </FormControl>
            </div>
            <div className={styles.filterInnerDiv}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Category</FormLabel>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={this.state.fruitsCheck}
                        onChange={this.handleChangeFruitsCheck}
                      />
                    }
                    label="Fruits"
                  />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={this.state.vegetablesCheck}
                        onChange={this.handleChangeVegetablesCheck}
                      />
                    }
                    label="Vegetables"
                  />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={this.state.meatCheck}
                        onChange={this.handleChangeMeatCheck}
                      />
                    }
                    label="Meat"
                  />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={this.state.otherCheck}
                        onChange={this.handleChangeOtherCheck}
                      />
                    }
                    label="Other"
                  />
                </FormGroup>
              </FormControl>
            </div>
            <div className={styles.filterInnerDiv}>
              <span>Within</span>
              <br />
              <TextField
                label={'Number of Miles'}
                value={this.state.miles}
                onChange={this.handleChangeMiles}
              />
              <br />
              <br />
              <span>miles of</span>
              <br />
              <TextField
                label={'Your Zip Code'}
                value={this.state.currentZipCode}
                onChange={this.handleChangeCurrentZipCode}
              />
              <br />
              <br />
              <span>zip code</span>
            </div>
          </div>

          <div className={styles.vl} />

          <div className={styles.postingsDiv}>
            {Object.keys(this.state.posts).map((post) => {
              let imageUrl =
                'https://firebasestorage.googleapis.com/v0/b/dewaste.appspot.com/o/networkImages%2F' +
                this.state.posts[post]['image'] +
                '?alt=media';
              let color = '#E3F2FD';
              if (this.state.posts[post]['type'] === 'buy') {
                color = '#FFF8E1';
              }
              if (this.state.posts[post]['active'] === true) {
                return (
                  <Card className={styles.networkCard} key={post}>
                    <CardActionArea
                      href={'https://de-waste.com/network/post/' + post}
                      className={styles.cardActionArea}
                    >
                      <img
                        className={styles.cardImage}
                        src={imageUrl}
                        alt={'https://de-waste.com/logo.png'}
                      />
                      <br />
                      <div
                        style={{ backgroundColor: color }}
                        className={styles.cardTextContainer}
                      >
                        <br />
                        <span className={styles.cardMainText}>
                          {this.state.posts[post]['post_title']}
                        </span>
                        <br />
                        <span className={styles.cardSecondaryText}>
                          ZIP: {this.state.posts[post]['zip_code']}
                        </span>
                      </div>
                    </CardActionArea>
                  </Card>
                );
              } else {
                return null;
              }
            })}
          </div>

          <div className={styles.rightSideDiv}>
            <div className={styles.activeRightNowDiv}>
              <span className={styles.activeRightNowText}>Active now</span>
              <br />
              <span
                style={{ float: 'right' }}
                className={styles.activeRightNowText}
              >
                {this.state.activeRightNow}
              </span>
            </div>
            <div className={styles.legend}>
              <div
                className={styles.legendColorBlock}
                style={{ backgroundColor: '#FFF8E1' }}
              />
              <span className={styles.legendLabel}>- Buying</span>
              <br />
              <br />
              <div
                className={styles.legendColorBlock}
                style={{ backgroundColor: '#E3F2FD' }}
              />
              <span className={styles.legendLabel}>- Selling</span>
            </div>
          </div>
        </div>
      </ThemeProvider>
    );
  }
}
